/**
 * Created by Administrador on 03/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('currencyService',currencyService);

    currencyService.$inject = ['$http', 'CONFIG','messageService'];

    function currencyService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/currencies';

        var service = {
            getCurrencies: getCurrencies,
            getPageCurrencies: getPageCurrencies,
            getCurrency: getCurrency,
            saveCurrency: saveCurrency,
            updateCurrency: updateCurrency,
            deleteCurrency: deleteCurrency
        };

        return service;

        function getCurrencies(){
            return $http.get(urlBase)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.currencies : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getPageCurrencies(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getCurrency(id){
            return $http.get(urlBase + "/" + id)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        }

        function saveCurrency(currency){
            return $http.post(urlBase, currency)
                .then(function(){
                    messageService.register('currencies');
                }, function(){
                    messageService.registerError('');
                });
        }

        function updateCurrency(currency, id){
            return $http.put(urlBase + "/" + id, currency)
                .then(function(){
                    messageService.registerUpdate('currencies');
                }, function(){
                    messageService.registerUpdateError('');
                });
        }

        function deleteCurrency(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('currencies');
                }, function(){
                    messageService.registerDeleteError('');
                })
        }
    }
})();
